import { SideNavService } from './_services/sidenav.service';
import {AfterViewChecked, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService, CanDeactivateService, GuiService, HeartbeatService, UserService, IntercomService} from './_services';
import '../assets/app.css';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {CanDeactivateServiceWrapper} from './_helpers/can-deactivate-service-wrapper';
import {NavigationStart, Router, NavigationEnd} from '@angular/router';
import {isCampaignSection, User} from './_models';

@Component({
  moduleId: module.id.toString(),
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css']
})
export class AppComponent implements  OnInit, AfterViewChecked {
  title: string = '';
  description: string = ''
  showWidgetBackground = false;
  canDeactivateService: CanDeactivateService = CanDeactivateServiceWrapper.getObject();
  public isSidebarExpanded = false;

  public isLegacyMenu = false;
  currentUser: User;
  isSSOCompletePage: boolean = false;
  public isCampaignSection: boolean = false;
  public isOrderManagementPortal: boolean = false;

  constructor(private translate: TranslateService, private authService: AuthenticationService,
              private modalService: NgxSmartModalService, private router: Router,
              protected guiService: GuiService, protected sideNavService: SideNavService, private userService: UserService,
              private heartBeatService: HeartbeatService, private cdr: ChangeDetectorRef, private intercomService: IntercomService) {
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.canDeactivateService.setRouteState(event.url);
        this.isCampaignSection = isCampaignSection(event.url)
        const path = event.url.split('?')[0];
        this.isOrderManagementPortal =
          path === '/order-management-portal' || path.startsWith('/order-management-portal/');
      }
      if (event instanceof NavigationEnd) {
        this.isSSOCompletePage = this.router.url === '/sso-complete';
      }
    });

    this.canDeactivateService.getSaveModalEventObs().subscribe(data => {
      if (data && data.open) {
        this.modalService.getModal('changesPopup').open();
      } else if (data && !data.open) {
        this.modalService.getModal('changesPopup').close();
      }
    });

    this.guiService.getGuiDataObs().subscribe(data => {
      if ('title' in data) {
        this.title = data.title;
      }
    });

    this.sideNavService.getSideNavObs().subscribe(data => {
      if ('isSideNavExpanded' in data) {
        this.isSidebarExpanded = data.isSideNavExpanded;
      }

      if ('isLegacyMenu' in data) {
        this.isLegacyMenu = data.isLegacyMenu;
      }
    });

    if (this.isLoggedIn()) {
      this.userService.getCurrent().subscribe(
        (user: User) => {
          this.currentUser = user;
          // Boot Intercom with user data (handles both fresh logins and existing sessions)
          if (user) {
            this.intercomService.boot(user);
          }
        },
        error => {
        }
      );
    }

    document.addEventListener('mousedown', () => {
      if (this.currentUser) {
        this.heartBeatService.beat();
      }
    });

    document.addEventListener('keypress', () => {
      if (this.currentUser) {
        this.heartBeatService.beat();
      }
    });

  }

  ngAfterViewChecked(){
    this.cdr.detectChanges();
  }

  isLoggedIn() {
    return this.authService.isLoggedIn() && this.authService.isNotAuth();
  }

  onActivate(component) {
    this.title = component.title;
    this.description = component.description;
    this.showWidgetBackground = !component.hideWidgetBackground && this.isLoggedIn()
  }

  onDeactivate(component) {
    this.title = '';
    this.showWidgetBackground = false;
  }

  closeChangesModal() {
    this.canDeactivateService.setSaveModalEvent('', false);
  }

  saveChanges() {
    this.canDeactivateService.setSaveModalEvent('save', false);
  }

  discardChanges() {
    this.canDeactivateService.setSaveModalEvent('discard', false);
  }
}
